"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Loops over each item of a sequence.
 *
 * <pre>
 * <ul>
 *  {% for user in users %}
 *    <li>{{ user.username|e }}</li>
 *  {% endfor %}
 * </ul>
 * </pre>
 */
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const syntax_1 = require("../error/syntax");
const set_1 = require("../node/set");
class TwingTokenParserSet extends token_parser_1.TwingTokenParser {
    parse(token) {
        let lineno = token.getLine();
        let columnno = token.getColumn();
        let stream = this.parser.getStream();
        let names = this.parser.getExpressionParser().parseAssignmentExpression();
        let capture = false;
        let values;
        if (stream.nextIf(token_1.TwingToken.OPERATOR_TYPE, '=')) {
            values = this.parser.getExpressionParser().parseMultitargetExpression();
            stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
            if (names.getNodes().size !== values.getNodes().size) {
                throw new syntax_1.TwingErrorSyntax('When using set, you must have the same number of variables and assignments.', stream.getCurrent().getLine(), stream.getSourceContext());
            }
        }
        else {
            capture = true;
            if (names.getNodes().size > 1) {
                throw new syntax_1.TwingErrorSyntax('When using set with a block, you cannot have a multi-target.', stream.getCurrent().getLine(), stream.getSourceContext());
            }
            stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
            values = this.parser.subparse([this, this.decideBlockEnd], true);
            stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        }
        return new set_1.TwingNodeSet(capture, names, values, lineno, columnno, this.getTag());
    }
    decideBlockEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endset');
    }
    getTag() {
        return 'set';
    }
}
exports.TwingTokenParserSet = TwingTokenParserSet;
